/** Serializable field metadata; behavior is supplied by the hosting form. */
export interface FormFieldAction {
	id: string;
	label: string;
	text?: string;
	disabled?: boolean;
	popup?: boolean;
	linked?: string;
	linked_value?: unknown;
}

export interface FormFieldActionEvent {
	action: FormFieldAction;
	name: string;
	path: string;
	value: unknown;
	data: Record<string, unknown>;
	/** False when the originating field is no longer current or editable. */
	setValue: (value: unknown) => boolean;
}

export const fieldActionDependency = (action: FormFieldAction, data: Record<string, unknown>): unknown =>
	action.linked?.split(".").reduce<unknown>((current, key) => current && typeof current === "object" ? (current as Record<string, unknown>)[key] : undefined, data);

export const fieldActionVisible = (action: FormFieldAction, data: Record<string, unknown>): boolean => !action.linked ||
	(Array.isArray(action.linked_value) ? action.linked_value.includes(fieldActionDependency(action, data)) : fieldActionDependency(action, data) === action.linked_value);

export const parseFieldActions = (value: unknown): FormFieldAction[] => Array.isArray(value) ? value.filter((action): action is FormFieldAction =>
	!!action && typeof action === "object" && typeof action.id === "string" && typeof action.label === "string" &&
	(action.linked === undefined || typeof action.linked === "string") &&
	(action.text === undefined || typeof action.text === "string") &&
	(action.disabled === undefined || typeof action.disabled === "boolean") &&
	(action.popup === undefined || typeof action.popup === "boolean"),
) : [];
